import { render, staticRenderFns } from "./FontPairingCreate.vue?vue&type=template&id=722c1322"
import script from "./FontPairingCreate.vue?vue&type=script&lang=js"
export * from "./FontPairingCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports